var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 22.4011H0.8C0.36 22.4011 0 22.7611 0 23.2011C0 23.6411 0.36 24.0011 0.8 24.0011H23.2C23.64 24.0011 24 23.6411 24 23.2011C24 22.7611 23.64 22.4011 23.2 22.4011ZM22.4 19.7851H21.6V11.8971H22.096C22.536 11.8971 22.896 11.5371 22.896 11.0971C22.896 10.6571 22.536 10.2971 22.096 10.2971H1.904C1.464 10.2971 1.104 10.6571 1.104 11.0971C1.104 11.5371 1.464 11.8971 1.904 11.8971H2.4V19.7851H1.6C1.16 19.7851 0.8 20.1451 0.8 20.5851C0.8 21.0251 1.16 21.3851 1.6 21.3851H22.4C22.84 21.3851 23.2 21.0251 23.2 20.5851C23.2 20.1451 22.84 19.7851 22.4 19.7851ZM9.712 19.7851H6.984V11.8971H9.712V19.7851ZM17.016 19.7851H14.288V11.8971H17.016V19.7851ZM23.568 5.83306L12.368 0.0890611C12.2558 0.0299271 12.1308 -0.000976562 12.004 -0.000976562C11.8772 -0.000976563 11.7522 0.0299271 11.64 0.0890611L0.432 5.83306C0.168 5.96906 0 6.24106 0 6.54506V8.48106C0 8.92106 0.36 9.28106 0.8 9.28106H23.2C23.64 9.28106 24 8.92106 24 8.48106V6.54506C24 6.24106 23.832 5.96906 23.568 5.83306ZM12.016 6.32906C11.368 6.32906 10.816 5.80106 10.816 5.15306C10.816 4.50506 11.32 3.97706 11.968 3.97706H12.016C12.664 3.97706 13.192 4.50506 13.192 5.15306C13.192 5.80106 12.664 6.32906 12.016 6.32906Z",
    fill: "#43C1F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.925c0310f7d92e6c61be56949c5bf217.svg";
export { ForwardRef as ReactComponent };